import { useEffect, useState } from "react";

const ExportArrowIcon = ({ className, fill = "#2e2e2e" }) => {
  const [_class, setClass] = useState(className);

  useEffect(() => {
    let classStr = className || "";
    if (!classStr.includes("w-")) {
      classStr += " w-5";
    }
    if (!classStr.includes("h-")) {
      classStr += " h-5";
    }

    setClass(classStr);
  }, [className]);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 20 20"
      strokeWidth="0"
      stroke={fill}
      className={_class}
    >
      <path
        d="M17.2896 3.33332V7.49999C17.2896 7.66575 17.2237 7.82472 17.1065 7.94193C16.9893 8.05914 16.8303 8.12499 16.6646 8.12499C16.4988 8.12499 16.3398 8.05914 16.2226 7.94193C16.1054 7.82472 16.0396 7.66575 16.0396 7.49999V4.84249L9.60625 11.275C9.48777 11.3854 9.33106 11.4455 9.16915 11.4426C9.00723 11.4398 8.85274 11.3742 8.73823 11.2597C8.62372 11.1452 8.55813 10.9907 8.55527 10.8288C8.55241 10.6668 8.61251 10.5101 8.72291 10.3917L15.1554 3.95832H12.4979C12.3322 3.95832 12.1732 3.89248 12.056 3.77526C11.9388 3.65805 11.8729 3.49908 11.8729 3.33332C11.8729 3.16756 11.9388 3.00859 12.056 2.89138C12.1732 2.77417 12.3322 2.70832 12.4979 2.70832H16.6646C16.8301 2.70898 16.9887 2.77504 17.1058 2.89211C17.2229 3.00918 17.2889 3.16777 17.2896 3.33332ZM16.6646 10.2083C16.4988 10.2083 16.3398 10.2742 16.2226 10.3914C16.1054 10.5086 16.0396 10.6676 16.0396 10.8333V14.1667C16.0396 15.4808 15.4787 16.0417 14.1646 16.0417H5.83125C4.51708 16.0417 3.95625 15.4808 3.95625 14.1667V5.83332C3.95625 4.51916 4.51708 3.95832 5.83125 3.95832H9.16458C9.33034 3.95832 9.48931 3.89248 9.60652 3.77526C9.72373 3.65805 9.78958 3.49908 9.78958 3.33332C9.78958 3.16756 9.72373 3.00859 9.60652 2.89138C9.48931 2.77417 9.33034 2.70832 9.16458 2.70832H5.83125C5.40903 2.65939 4.98121 2.70655 4.5798 2.8463C4.17839 2.98604 3.81377 3.21474 3.51322 3.51529C3.21266 3.81584 2.98396 4.18046 2.84422 4.58188C2.70448 4.98329 2.65731 5.41111 2.70625 5.83332V14.1667C2.65731 14.5889 2.70448 15.0167 2.84422 15.4181C2.98396 15.8195 3.21266 16.1841 3.51322 16.4847C3.81377 16.7852 4.17839 17.0139 4.5798 17.1537C4.98121 17.2934 5.40903 17.3406 5.83125 17.2917H14.1646C14.5868 17.3406 15.0146 17.2934 15.416 17.1537C15.8174 17.0139 16.1821 16.7852 16.4826 16.4847C16.7832 16.1841 17.0119 15.8195 17.1516 15.4181C17.2914 15.0167 17.3385 14.5889 17.2896 14.1667V10.8333C17.2896 10.6676 17.2237 10.5086 17.1065 10.3914C16.9893 10.2742 16.8303 10.2083 16.6646 10.2083Z"
        fill="#2E79EB"
      />
    </svg>
  );
};

export default ExportArrowIcon;
